// extracted by css-extract-rspack-plugin
export default {"formControlLabel":"formControlLabel-OpJMKt"};